import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    salutation: string,
    street: string,
    postalCode: string,
    city: string,
    country: string,
    jobCategory: string,
    periodFrom: Date | null,
    periodTo: Date | null,
    becomingAwareThrough: string,
    recommendation: string,
    salaryRequest: number | null,
    periodOfCancellation: string,
    mobileNumber:string,
    pid:string,
    it:string
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    salutation: string = "";
    street: string = "";
    postalCode: string = "";
    city: string = "";
    country: string = "";
    jobCategory: string = "";
    periodFrom: Date | null = null;
    periodTo: Date | null = null;
    becomingAwareThrough: string = "";
    recommendation: string = "";
    salaryRequest: number | null = null;
    periodOfCancellation: string = "";
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    mobileNumber:string="";
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string="";
    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "salutation", value: this.salutation },
            { name: "street", value: this.street },
            { name: "postalCode", value: this.postalCode },
            { name: "city", value: this.city },
            { name: "country", value: this.country },
            { name: "jobCategory", value: this.jobCategory },
            { name: "periodFrom", value: this.periodFrom?.toString() ?? "" },
            { name: "periodTo", value: this.periodTo?.toString() ?? "" },
            { name: "becomingAwareThrough", value: this.becomingAwareThrough },
            { name: "recommendation", value: this.recommendation },
            { name: "salaryRequest", value: this.salaryRequest?.toString() ?? "" },
            { name: "periodOfCancellation", value: this.periodOfCancellation },
            { name: "mobileNumber", value: this.mobileNumber },
        );

        return application;
    }
}
